import { User } from "src/models/user";

export interface Restaurant {
    id: number;
    name: string;
    logo: string;
    description: string;
    registrationNumber: string;
    categoryName: string;
    tenantCode: string;
    galleryImages: string[];
    contact?: Contact;
    locations: StoreLocation[];
    websiteUrl: string;
    featureImage: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export interface Contact {
    id: number;
    personName: string;
    email: string;
    phone: string;
    jobTitlte: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export interface StoreLocation {
    id?: number;
    name?: string;
    isPrimary?: boolean;
    restaurantId: number;
    startHour?: Date;
    endHour?: Date;
    addressType?: string;
    addressLine?: string;
    addressLine2?: string;
    city?: string;
    cityCode?: string;
    state?: string;
    stateCode?: string;
    country?: string;
    countryCode?: string;
    zip?: string;
    geoLoc?: GeoLoc;
    isActive?: boolean;
    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export interface GeoLoc {
    lat: string;
    lng: string;
}


export interface Category {
    id?: string,
    parentCategoryId?: string,
    name: string,
    description?: string,
    featureImage: string,
    isActive?: boolean,
    createdBy?: string;
    createdOn?: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface Size {
    id?: number,
    name: string,
    isActive: boolean,
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface AddOnCategory {
    id?: string,
    name: string,
    description: string,
    isActive: boolean,
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface AddOnItem {
    id: string;
    name: string;
    featureImage: string;
    description: string;
    categories: AddOnCategory[];
    price: number;
    isActive: boolean;
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface FoodCategory {
    id: number,
    name: string,
    description: string,
    featureImage: string,
    parentCategoryId?: number,
    isActive: boolean,
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface CuisineType {
    id?: number,
    name: string,
    description: string,
    isActive: boolean,
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface ItemSize {
    id?: number,
    name: string,
    description: string,
    isActive: boolean,
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface FoodItemAddOn {
    id?: number;
    multipleSelection: boolean;
    isRequired: boolean;
    addOnCategory: AddOnCategory;
    addOnItems: AddOnItem[];
}

export interface AddOnItem {
    id: string;
    name: string;
    description: string;
    price: number;
    featureImage: string;
    categories: AddOnCategory[];
}

export interface FoodItem {
    id: number,
    restaurantId: number,
    restaurantLocationId?: number,
    name: string,
    itemCode: string,
    description: string,
    featureImage: string,
    twoFlavor: boolean,
    galleryImages: string[],
    cuisineType?: CuisineType,
    foodCategories: FoodCategory[];
    itemPrices: ItemPrice[];
    ingredients: Ingredient[];
    addOns: FoodItemAddOn[];
    isActive: boolean,
    createdBy: string;
    createdOn: Date,
    updatedBy?: string;
    updatedOn?: Date;
}

export interface CodeItem {
    id?: string;
    code: string;
    value: string;
    name?: string;
    appName?: string;
}

export interface NameItem {
    id: string;
    name: string;
}

export interface Ingredient {
    id?: string,
    name: string,
    description?: string,
    icon?: string,
    isActive?: boolean,
    createdBy?: string;
    createdOn?: Date,
    updatedBy?: string;
    updatedOn?: Date;
}



export interface FoodPack {
    id: number;
    name: string;
    description: string;
    tenantCode: string;
    Type: FoodPackTypes;
    price: number;
    priceRemark: string;
    restaurantLocationId?: number,
    featureImages: string[];
    noOfDelivery: number;
    deliveryGroups: FoodPackDeliveryGroup[];
    isActive: boolean;
    createdBy: Date;
    createdOn: string;
    updatedBy?: string;
    updatedOn?: Date;
}

export interface FoodPackDeliveryGroup {
    name: string;
    description: string;
    categories: FoodPackCategory[];
}

export interface FoodPackCategory {
    name: string;
    description: string;
    foodItemIds: number[];
    foodItems: FoodItem[];
    minimumItemCount?: number;
    maximumItemCount?: number;
}

export enum FoodPackTypes {
    None = 'None',
    Monthly = 'Monthly',
    Weekly = 'Weekly',
}

export interface ItemPrice {
    id?: number;
    priceType: 'all' | 'cash' | 'card';
    price: number;
    priceDesc?: string;
    discount?: number;
    discountDesc?: string;
    priceAfterDiscount?: number;
    priceAfterDiscountDesc?: string;
}

export interface Item {
    id: string;
    name: string;
    code?: string;
    sku?: string;
    isAvailable?: boolean;
    showOnPos?: boolean;
    description?: string;
    featureImage: string;
    images?: string[];
    categories?: Category[];
    variants?: ItemVariant[];
    hasVariants?: boolean;
    prices?: ItemPrice[];
    ingredients?: Ingredient[];
    addOns?: AddOnGroup[];
    isActive?: boolean;
    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export interface ItemVariantMain {
    id?: string;
    type: string;//size
    names: string[];//small, medium
    description: string;
}

export interface ItemVariant {
    id: string;
    type: string;//size
    name: string;//small, medium
    isAvailable: boolean;
    prices?: ItemPrice[];
}

export interface AddOnGroup {
    id?: string;
    groupName: string;
    featureImage?: string;
    isRequired?: boolean;
    maxSelection?: number;
    addOnItems?: AddOnItem[];
}

export interface PriceMenu {
    id: string;
    title: string;
    description?: string;
    coverImage?: string;
    availabilityType?: 'na' | 'allday' | 'slot';
    availabilitySlot?: {
        from: Date;
        to: Date;
    };
    template?: string;
    items: Item[];
}

export enum OrderTypes {
    TableOrder = 'TableOrder',
    TakeAway = 'TakeAway',
    Online = 'Online',
    Kiosk = 'Kiosk'
}


export interface OrderStage {
    name: string;
    type: string;
    createdOn: Date;
    updatedOn?: Date;
}
export interface PriceEnhancer {
    type: 'Tax' | 'ServiceChange';
    amount: number;
    description?: string;
}

export interface DiscountCoupon {
    type: 'Discount';
    code: string;
    amount: number;
    description?: string;
    createdBy?: string;
}

export interface OrderItem {
    itemId: string;
    itemName?: string;
    itemCode?: string;
    description?: string;
    price: number;
    categories?: string[];
    featureImage?: string;
    quantity: number;
    variantId?: string;
    cookingNote?: string;
    addOns?: { id: string }[];
    isDelivered?: boolean;
    isPaid?: boolean;
    customerName?: string;
    customerMobileNumber?: string;
    customerId?: string;
}
export interface Customer {
    id: string;
    fullName: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    image?: string;
    email?: string;
    type?: string;
}

export type PriceTypes = 'all' | 'card' | 'cash';

export interface OrderMain {
    id: string;
    orderType: OrderTypes;
    orderNumber: string;
    tableNumber: string;
    currentStage: OrderStage;
    cookingNote?: string;
    deliveryNote?: string;
    priceEnhancers?: PriceEnhancer[];
    coupons?: DiscountCoupon[];
    orderAmount: number;
    items: OrderItem[];
    location?: CodeItem;
    priceType?: PriceTypes; //card, cash
    menuTitle?: string;
    sourceApp: CodeItem;
    tenantCode: string;
    createdBy?: User;
    createdOn: Date;
    updatedOn?: Date;
    customer?: Customer;
}
export interface OrderMainTrack {
    id: string;
    tenantCode: string;
    orderId: string;
    orderStages?: OrderStage[];
    updatedBy?: User;
    updatedOn?: Date;
}

export interface Employee {
    id: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    fullName?: string;
    email: string;
    altEmail?: string;
    code?: string;
    contactNumber?: string;
    altContactNumber?: string;
    description?: string;
    pronouns?: string;
    image?: string;
    teams: CodeItem[];
    departments?: CodeItem[];
    jobTitle?: CodeItem;
    dateOfBirth?: Date;
    dateOfJoining?: Date;
    isActive: boolean;
    address?: Address;
    userRoles: UserRoles[];
    userPin?: string;
}
export interface UserRoles {
    label: string;
    value: string;
}
export interface UserRoles {
    label: string;
    value: string;
}

export interface Address {
    name?: string;
    isPrimary?: boolean;
    addressType?: string;
    addressLine?: string;
    addressLine2?: string;
    city?: string;
    cityCode?: string;
    state?: string;
    stateCode?: string;
    country?: string;
    countryCode?: string;
    zipCode?: string;
    geoLoc?: GeoLoc;
}

export interface RefData {
    items: CodeItem[];
}
export interface ItemRecommend {
    id?: string;
    itemId: string;
    categories?: string[];
    excludedItemIds?: string[];
    itemIds?: string[];
    disabled?: boolean;
    updatedBy?: string;
    createdBy?: string;
    createdOn?: Date;
    updatedOn?: Date;
}


export interface DineLayoutSection {
    id?: string;
    name: string;
    description?: string;
    featureImage?: string;
    isActive: boolean;
    tables?: DineTable[];
}

export interface DineTable {
    id?: string;
    sectionName: string;
    tableName: string;
    tableShape: string;
    capacity: number;
    isActive: boolean;
}

export interface Merchant {
    id?: string;
    tenantCode?: string;
    name?: string;
    displayName?: string;
    dualPrice?: boolean;
    dualPricePercentage?: number;
    featureImage?: string;
    logo?: string;
    coverImage?: string;
    caption?: string;
    description?: string;
    isActive?: boolean;
    statusDesc?: string;
    email?: string;
    contactNumber?: string;
    contactPerson?: string;
    auth0ClientId?: string;
}

export interface ClientApp {
    id: string;
    printerProfile: string;
    deviceId: string;
    tenantCode: string;
    appName: string;
    deviceType: string;
    clientApiKey: string;
    clientApiSecrete: string;
    isActive: boolean;
    valorPaySetting?: ValorPaySetting;
}

export interface ValorPaySetting {
    channelId?: string;
    EPI?: string;
    tranMode?: string;
    tranCode?: string;
    appId?: string;
    appKey?: string;
    txnType?: string;
    version?: string;
}

export interface Printer {
    id: string; // Mongoose ObjectId as string
    tenantCode: string;
    name: string;
    description?: string;
    macAddress?: string;
    ipAddress?: string;
    port?: string;
    icon?: string;
    driver: string[];
    isActive?: boolean;
    updatedBy?: string;
    createdBy?: string;
    createdOn: Date;
    updatedOn?: Date;
}

export interface PrinterProfile {
    id: string; // Mongoose ObjectId as string
    tenantCode: string;
    name: string;
    description?: string;
    printers?: string[];
    // icon?: string;
    numberOfCopies: string;
    isDefault: boolean;
    // driver: string;
    // isActive?: boolean;
    updatedBy?: string;
    createdBy?: string;
    createdOn: Date;
    updatedOn?: Date;
}

// 


// Discount interface
export interface Discount {
    id?: string;
    code?: string;
    value?: {
        type: PromotionTypeEnum;
        value: number;
    };
    minimumAmount?: number;
    minimumQty?: number;
    customerGroups?: string[];
    customerTypes?: PromotionCustomerTypeEnum[];
    applyOncePerCustomer?: boolean;
    applyTimesPerCustomer?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;
    combineWithDiscountCodes?: string[];
}


export interface ProductionCenter {
    id: string;
    tenantCode: string;
    name: string;
    description?: string;
    printerProfileId?: string;
    printerProfileName?: string;
    categoryIds?: string[];
    itemIds?: string[];
    isActive?: boolean;
    updatedBy?: string;
    createdBy?: string;
    createdOn: Date;
    updatedOn?: Date;
}

// 
export enum PromotionTypeEnum {
    Percent = 'percent',
    FixedAmount = 'fixed-amount',
}

export enum PromotionApplyTargetEnum {
    Order = 'order',
    Product = 'product',
    Shipping = 'shipping',
    BuyGetx = 'item',
}

export enum PromotionCustomerTypeEnum {
    NewCustomer = 'new-customer',
    RepeatCustomer = 'repeat-customer',
    Registered = 'registered',
    Member = 'member',
}

export interface BatchClockData {
    appRegisterId: string;
    employeeId: {
        _id: string;
        firstName: string;
        lastName: string;
    };
    batchNumber: string;
    status: string;
    startAt: string;
    tenantCode: string;
    id: string;
}

// Discount interface
export interface Discount {
    id?: string;
    code?: string;
    value?: {
        type: PromotionTypeEnum;
        value: number;
    };
    minimumAmount?: number;
    minimumQty?: number;
    customerGroups?: string[];
    customerTypes?: PromotionCustomerTypeEnum[];
    applyOncePerCustomer?: boolean;
    applyTimesPerCustomer?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;
    combineWithDiscountCodes?: string[];
}
